var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebooka29A07E9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47715 0 0 4.50452 0 10.0611C0 15.083 3.65686 19.2453 8.4375 20V12.9694H5.89844V10.0611H8.4375V7.84455C8.4375 5.32297 9.93043 3.93013 12.2146 3.93013C13.3087 3.93013 14.4531 4.12664 14.4531 4.12664V6.60263H13.1921C11.9499 6.60263 11.5625 7.37818 11.5625 8.17383V10.0611H14.3359L13.8926 12.9694H11.5625V20C16.3431 19.2453 20 15.083 20 10.0611C20 4.50452 15.5229 0 10 0Z",
    fill: "#1A77F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_761_16479",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47715 0 0 4.50452 0 10.0611C0 15.083 3.65686 19.2453 8.4375 20V12.9694H5.89844V10.0611H8.4375V7.84455C8.4375 5.32297 9.93043 3.93013 12.2146 3.93013C13.3087 3.93013 14.4531 4.12664 14.4531 4.12664V6.60263H13.1921C11.9499 6.60263 11.5625 7.37818 11.5625 8.17383V10.0611H14.3359L13.8926 12.9694H11.5625V20C16.3431 19.2453 20 15.083 20 10.0611C20 4.50452 15.5229 0 10 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_761_16479)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebooka29A07E9);
export default __webpack_public_path__ + "static/media/facebook.a29a07e9.93f0edd0cb8e62c640a455975347a0d6.svg";
export { ForwardRef as ReactComponent };